<div style="float: left; margin-bottom: 2rem; margin-top: 1rem">
  <button (click)="openCreateUserDialog()" color="primary" mat-raised-button>{{ 'Create User' | translate }}</button>
</div>

<table [dataSource]="users" class="mat-elevation-z8" mat-table>
  <ng-container matColumnDef="fullName">
    <th *matHeaderCellDef mat-header-cell> {{ 'Full Name' | translate }}</th>
    <td *matCellDef="let user" mat-cell> {{user.fullName}} </td>
  </ng-container>

  <ng-container matColumnDef="email">
    <th *matHeaderCellDef mat-header-cell> {{ 'Email' | translate }} </th>
    <td *matCellDef="let user" mat-cell> {{user.email}} </td>
  </ng-container>

  <ng-container matColumnDef="role">
    <th *matHeaderCellDef mat-header-cell> {{ 'Role' | translate }} </th>
    <td *matCellDef="let user" mat-cell> {{user?.role[0]?.name}} </td>
  </ng-container>

  <ng-container matColumnDef="remove">
    <th *matHeaderCellDef mat-header-cell> {{ 'Remove' | translate }} </th>
    <td *matCellDef="let user" mat-cell>
      <a (click)="deleteUser(user.id)" style="cursor: pointer; color: red; font-size: 18px; margin-left: 1rem;">
        <i class="fa fa-remove"></i>
      </a>
    </td>
  </ng-container>

  <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
  <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
</table>

<mat-paginator [length]="totalItems" [pageSize]="pageSize"></mat-paginator>
